module.exports = __webpack_public_path__ + "img/card-background.4bafcf7.webp";